import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-loading-mark',
  templateUrl: './loading-mark.component.html',
  styleUrls: ['./loading-mark.component.scss']
})
export class LoadingMarkComponent { }
